import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import useDebouncedValue from '../useDebouncedValue';
import { searchChatsByCustomer } from '../../services/chats';
import useUser from '../global/useUser';

interface Options {
  enabled?: boolean;
}

function useSearchChatsByCustomers(customerIds: string[], options?: Options) {
  const enabled = options?.enabled ?? true;

  const sortedIds = useMemo(() => [...customerIds].sort(), [customerIds]);

  const debouncedValue = useDebouncedValue(sortedIds, 250);
  const { user } = useUser();
  const businessId = user?.business?.id;

  const { data, isLoading, isFetching, isError, error } = useQuery({
    queryKey: ['search-chats', debouncedValue, businessId],
    queryFn: async () => {
      if (!debouncedValue) return [];
      const result = await searchChatsByCustomer({
        customerIds: debouncedValue,
        businessId: businessId!,
      });
      return result;
    },
    enabled: !!businessId && enabled,
  });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    error,
  };
}

export default useSearchChatsByCustomers;
